export default {
  getPatients: state => state.patients,
  getCachedPersonalData: state => state.cachedPersonalData,
  getPatientVisualInspectionList: state => state.patientVisualInspectionList,
  getVisualInspection: state => state.visualInspection,
  getPatientCommonDiseasesList: state => state.patientCommonDiseasesList,
  patientDentalStatusList: state => state.patientDentalStatusList,
  getDiseases: state => state.diseases,
  getTotalCount: state => state.totalCount,
  getPatient: state => state.patient,
  patientsForDropdown: state => state.patientsForDropdown,
  getDentalFiles: state => state.dentalFiles,
  getTeeth: state => state.teeth,
  getTeethMap: state => state.teethMap,
  getTeethStatuses: state => state.teethStatuses,
  getRowNumbers: state => state.rowNumbers,
  getPatientTreatmentPlan: state => state.patientTreatmentPlan,
  getPatientTreatmentDiaries: state => state.patientTreatmentDiaries,
  getPatientTreatmentDiariesPerPage: state => state.patientTreatmentDiariesPerPage,
  getPatientTreatmentDiariesPerPageTotalCount: state => state.patientTreatmentDiariesPerPageTotalCount,
  getMobilePhoneCodes: state => state.mobilePhoneCodes,
  getDocumentTypes: state => state.documentTypes,
  getPatientAdvisoryOpinions: state => state.advisoryOpinions,
  getLeadHistoryPerPage: state => state.leadHistoryPerPage,
  getLeadHistoryPerPageTotalCount: state => state.leadHistoryPerPageTotalCount,
  getPhysicianProtocolHistory: state => state.physicianProtocolHistory,
  getSynevoAnalysesOrders: state => state.synevoAnalysesOrders,
  getPatientSynevoAnalysisOrderStatus: state => state.patientSynevoAnalysisOrderStatus,
  getOutpatientSurgeryHistory: state => state.outpatientSurgeryHistory,
  dentalCardInsertForm1K: state => state.dentalCardInsertForm1K,
  dentalCardInsertForm1M: state => state.dentalCardInsertForm1M,
  dentalCardInsertFormOrthopedic: state => state.dentalCardInsertFormOrthopedic,
  dentalCardInsertFormOrthodontic: state => state.dentalCardInsertFormOrthodontic,
  dentalCardInsertForm1MResults: state => state.dentalCardInsertForm1MResults,
  dentalCardStates: state => state.dentalCardStates,
  getCallHistoryPerPage: state => state.callHistoryPerPage,
  getCallHistoryPerPageTotalCount: state => state.callHistoryPerPageTotalCount,
  insuranceHistory: state => state.insuranceHistory,
  certificateHistory: state => state.certificateHistory,
  dentalWorkHistory: state => state.dentalWorkHistory,
  recommendedVisitsPerPage: state => state.recommendedVisitsPerPage,
  recommendedVisitsPerPageCount: state => state.recommendedVisitsPerPageCount,
  treatmentPresentations: state => state.treatmentPresentations,
  treatmentTypes: state => state.treatmentTypes,
}
